<template>
  <div class="comment-item flex">
    <a href="javascript:;" class="cursor-default" @click="navigateToUserCenter">
      <UserAvatar :src="comment.userInfo.headImgUrl" :shape="shape" />
    </a>
    <div class="comment-wrapper">
      <div class="comment-info">
        <div class="comment-top">
          <a
            href="javascript:;"
            class="cursor-default"
            @click="navigateToUserCenter"
          >
            <span class="user-name">{{
              comment.userInfoExtend || comment.userInfo.name
            }}</span>
          </a>
          <span :class="commentClassName">：{{ initCommentContent }}</span>
        </div>
        <div class="comment-bottom flex">
          <span class="create-time">{{ date }}</span>
          <p class="handle-wrapper" v-if="operationBtn">
            <span class="handle-action" ref="handleBtn" @click="handleAction">{{
              operationText
            }}</span>
            <span
              class="handle-icon"
              :class="praiseCondition"
              @click="praiseComment"
            ></span>
            <span class="handle-count">{{ initPraiseCount }}</span>
          </p>
        </div>
        <div class="reply-area" v-show="displayInput" v-if="notMine">
          <div class="input-wrapper">
            <el-input
              type="textarea"
              resize="none"
              maxlength="100"
              show-word-limit
              :autosize="{ minRows: 2 }"
              :placeholder="inputHolder"
              v-model="replyContent"
            ></el-input>
          </div>
          <div class="reply-wrapper flex">
            <span></span>
            <el-button
              class="send-reply"
              :disabled="forbidReply"
              @click="submitReply"
              >发送</el-button
            >
          </div>
        </div>
        <div class="reply-list-wrapper">
          <ReplyItem
            v-for="(item, index) in replyList"
            :key="index"
            :reply="item"
            :deleteStatus="item.isDeleted"
            :showStatus="item.isShow"
            :showScene="replyScene"
            @handleDelete="deleteReply"
          />
        </div>
      </div>
      <div class="all-replay-container" v-if="replyCount > 4">
        <div class="more-btn-container">
          <el-button
            class="all-replay-btn"
            :disabled="loadMoreBtn"
            @click="loadAllReply"
            >查看更多回复</el-button
          >
        </div>
        <el-dialog
          title="查看回复"
          :visible.sync="dialogVisible"
          :before-close="handleClose"
          custom-class="handlian-all-reply"
          width="625px"
        >
          <AllReply
            :curComment="comment"
            :replyList="newReplyList"
            @resetReplyList="renewalReply"
          />
          <div slot="footer" class="dialog-footer">
            <el-pagination
              layout="prev, pager, next"
              :total="totalPage"
              prev-text="上一页"
              next-text="下一页"
              @current-change="curCommentPageClick"
            ></el-pagination>
            <!-- @prev-click="prevCommentPageClick" @next-click="nextCommentPageClick" -->
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import UserAvatar from "../../components/UserAvatar";
import AllReply from "./all-reply";
import { getFullDate } from "../../utils/date";
import { tranNumber } from "../../utils/feed";
import ReplyItem from "./reply-item";
import { apiMap } from "../../utils/apiMap";
export default {
  name: "comment-item",
  props: {
    comment: Object,
    replyList: Array,
    replyCount: Number,
    showStatus: Number,
    deleteStatus: Number,
  },
  data() {
    return {
      shape: "terse",
      replyContent: "",
      replyTotal: 0,
      curReplyPage: 1,
      newReplyList: [],
      forbidReply: true,
      displayInput: false,
      praised: false,
      notMine: false,
      operationBtn: true,
      dialogVisible: false,
      loadMoreBtn: false,
      replyScene: "commentList",
    };
  },
  components: {
    UserAvatar,
    ReplyItem,
    AllReply,
  },
  mounted() {
    // this.$bus.$on('update-reply-list', this.renewalReply)
    // if (this.comment.praiseStatus==1) {
    //     this.praised = true;
    // }
    // if (this.comment.userId==this.user.userId) {
    //     this.notMine = false
    // }
    // this.replyList = this.comment.replyData
  },
  computed: {
    ...mapGetters(["user"]),
    date() {
      return getFullDate(new Date(this.comment.created_at * 1000));
    },
    inputHolder() {
      return `回复${this.comment.userInfoExtend || this.comment.userInfo.name}`;
    },
    initPraiseCount() {
      return tranNumber(this.comment.praise);
    },
    praiseCondition() {
      if (this.comment.praiseStatus == 1) {
        return "praised";
      } else {
        return "unpraise";
      }
    },
    commentClassName() {
      if (this.comment.isDeleted == 1 || this.comment.isShow == 0) {
        return `withdrawn-text`;
      } else {
        return `comment-text`;
      }
    },
    operationText() {
      if (this.comment.userId !== this.user.userId) {
        this.notMine = true;
        return "回复";
      } else {
        this.notMine = false;
        return "删除";
      }
    },
    initCommentContent() {
      if (this.deleteStatus == 1) {
        this.operationBtn = false;
        return `[该评论已删除]`;
      } else if (this.showStatus == 0) {
        this.operationBtn = false;
        return `[该评论已被系统屏蔽]`;
      } else {
        this.operationBtn = true;
        return this.comment.content;
      }
    },
    totalPage() {
      return this.replyTotal;
    },
  },
  methods: {
    praiseComment() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["praiseComment"]["method"],
          url: apiMap["praiseComment"]["url"],
          data: `token=${loginUser.token}&commentId=${_this.comment.id}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (_this.comment.praiseStatus == 1) {
              if (_this.comment.praise > 0) {
                _this.comment.praise -= 1;
              }
              _this.comment.praiseStatus = 0;
            } else {
              _this.comment.praise += 1;
              _this.comment.praiseStatus = 1;
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      // if (this.comment.praiseStatus == 1) {
      //     if (this.comment.praise > 0) {
      //         this.comment.praise -= 1;
      //     }
      //     this.comment.praiseStatus = 0
      // } else {
      //     this.comment.praise += 1;
      //     this.comment.praiseStatus = 1
      // }
    },
    handleAction(e) {
      if (this.comment.userId !== this.user.userId) {
        if (e.target.innerText == "回复") {
          e.target.innerText = "取消";
          this.displayInput = true;
        } else {
          e.target.innerText = "回复";
          this.displayInput = false;
        }
      } else {
        this.$confirm("确定删除该评论吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
          closeOnClickModal: false,
        })
          .then(() => {
            this.removeComment((res) => {
              if (res == 1) {
                this.$emit("handleDelete", this.comment.id);
              } else {
                this.$message({
                  message: "删除失败，稍后再试",
                  type: "warning",
                  duration: 1500,
                  offset: 230,
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    removeComment(cb) {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["removeComment"]["method"],
        url: apiMap["removeComment"]["url"],
        data: `token=${loginUser.token}&commentId=${this.comment.id}&type=1`,
      })
        .then(function(response) {
          cb(response.data.result.statusCode);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteReply(replyID) {
      // this.$emit('handleReload');
      var findIndex = -1;
      this.replyList.filter((item, index) => {
        if (item.id == replyID) {
          findIndex = index;
        }
      });
      if (findIndex != -1) {
        this.replyList.splice(findIndex, 1);
      }
    },
    submitReply() {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["replyComment"]["method"],
          url: apiMap["replyComment"]["url"],
          data: `token=${loginUser.token}&commentId=${this.comment.id}&commentUserId=${this.comment.userId}&content=${this.replyContent}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var myReply = {
              commentId: response.data.result.data.commentId,
              commentUserId: $this.comment.userId,
              content: $this.replyContent,
              created_at: Math.round(new Date() / 1000),
              id: $this.comment.id,
              isDeleted: 0,
              isShow: 1,
              praiseStatus: 0,
              replyToUserInfo: $this.comment.userInfo,
              replyToUserInfoExtend: null,
              replyUserInfo: {
                headImgUrl: loginUser.headImgUrl,
                name: loginUser.nickName,
                realName: null,
                thumbHeadImg: loginUser.thumbHeadImg,
              },
              replyUserInfoExtend: loginUser.nickName,
              updated_at: null,
              userId: loginUser.userId,
            };
            $this.replyList.push(myReply);
            $this.replyContent = "";
            $this.$refs.handleBtn.click();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadAllReply(e) {
      this.loadMoreBtn = true;
      if (e.target.innerText == "查看更多回复") {
        e.target.innerText = "拼命加载中…";
        this.getReplyList(1, (res) => {
          this.newReplyList = res;
          this.dialogVisible = true;
          this.loadMoreBtn = false;
          e.target.innerText = "查看更多回复";
        });
      }
    },
    getReplyList(start, cb) {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["replyList"]["method"],
          url: apiMap["replyList"]["url"],
          data: `token=${loginUser.token}&commentId=${this.comment.id}&start=${start}&count=10`,
        })
        .then(function(response) {
          // console.log(response)
          // response.data.result.count 总回复条数
          // response.data.result.data.commentData 回复的父级评论
          // response.data.result.data.replyData 回复列表
          if (response.data.result.statusCode == 1) {
            $this.replyTotal = response.data.result.count;
            cb(response.data.result.data.replyData);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    prevCommentPageClick(newPage) {
      //即将加载的起始页
      // this.commentShade = true;
      this.curReplyPage = newPage;
      this.getReplyList(newPage, (res) => {
        console.log(res);
        this.newReplyList = res;
      });
    },
    curCommentPageClick(newPage) {
      //即将加载的起始页
      // this.commentShade = true;
      this.curReplyPage = newPage;
      this.getReplyList(newPage, (res) => {
        console.log(res);
        this.newReplyList = res;
      });
    },
    nextCommentPageClick(newPage) {
      // this.commentShade = true;
      this.curReplyPage = newPage;
      this.getReplyList(newPage, (res) => {
        console.log(res);
        this.newReplyList = res;
      });
    },
    handleClose(done) {
      this.$emit("handleReload");
      done();
    },
    renewalReply() {
      this.getReplyList(this.curReplyPage, (res) => {
        console.log(res);
        this.newReplyList = res;
      });
    },
    navigateToUserCenter() {
      var checkArr = ["/clanFeed", "/detail"];
      if (this.comment.userId && !checkArr.includes(this.$route.path)) {
        this.$router.push({
          path: "/feed",
          query: {
            id: this.comment.userId,
          },
        });
      }
    },
  },
  watch: {
    replyContent(text) {
      if (text === "" || text.trim().length === 0) {
        this.forbidReply = true;
      } else {
        this.forbidReply = false;
      }
    },
  },
};
</script>
<style scoped>
.comment-item {
  position: relative;
  padding: 4px;
}

.comment-item:not(:last-child):after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  margin: 0 20px;
  border-bottom: 1px solid #f6f6f6;
  content: "";
}

.comment-info {
  margin-left: 5px;
}

.comment-top {
  line-height: 22px;
}

.comment-top a {
  color: #1a70db;
}

.comment-bottom {
  width: 748px;
  line-height: 20px;
  justify-content: space-between;
}

.comment-bottom .create-time {
  color: #999;
}

.handle-wrapper {
  line-height: 20px;
}

.handle-action {
  display: none;
  color: #1a70db;
  margin-right: 15px;
  cursor: pointer;
}

.comment-item:hover .handle-action {
  display: inline-block;
}

.handle-icon {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 19px;
  height: 17px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
}

.handle-count {
  margin-left: 5px;
  color: #e74f52;
}

.unpraise {
  background-image: url("../../assets/icon/cl_feed_praise.png");
}

.praised {
  background-image: url("../../assets/icon/cl_feed_praised.png");
}

.input-wrapper {
  margin: 4px 0;
}

.input-wrapper .el-textarea__inner {
  min-height: 50px;
}

.reply-wrapper {
  justify-content: space-between;
}

.send-reply {
  padding: 4px 10px;
}

.withdrawn-text {
  color: #999;
}

.more-btn-container {
  line-height: 30px;
  text-align: center;
}

.all-replay-btn {
  padding: 0;
  color: #1a70db;
  background-color: #fff;
  border: none;
}

.dialog-footer {
  text-align: center;
}
</style>
